import styled, { css } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurMotion,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

import { ImageFitVariant, ImagePosition } from './model';

const cardSpacing = getPurpurSpacing('200');

export const Card = styled.div<{ $imagePosition: ImagePosition }>(
    ({ $imagePosition }) => css`
        all: unset;

        [hidden] {
            display: none;
        }

        position: relative;
        overflow: hidden;
        background-color: ${getPurpurColor('backgroundPrimary')};
        border-radius: ${getPurpurBorder('radiusMd')};
        display: grid;
        column-gap: ${getPurpurSpacing('200')};
        ${
            ($imagePosition === 'right' &&
                css`
                    grid-template:
                        'main image' auto
                        'children children' auto / 1fr auto;
                `) ||
            ($imagePosition === 'left' &&
                css`
                    grid-template:
                        'image main' auto
                        'children children' auto / auto 1fr;
                `)
        };

        &:after {
            content: '';
            inset: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            pointer-events: none;
            border-radius: ${getPurpurBorder('radiusMd')};
            transition: box-shadow ${getPurpurMotion('duration150')} ease;
            box-shadow: ${getPurpurColor('borderInteractiveSubtle')} 0 0 0 ${getPurpurBorder('widthXs')} inset;
        }
    `,
);

export const Extra = styled.div`
    grid-area: children;
`;

export const Image = styled.img<{ $imageFit?: ImageFitVariant; $imagePosition: ImagePosition }>(
    ({ $imageFit = 'cover', $imagePosition }) => css`
        grid-area: image;
        width: ${getPurpurSpacing('1000')};
        height: 100%;
        object-fit: cover;

        ${
            ($imageFit === 'contain' &&
                css`
                max-height: ${getPurpurSpacing('1000')};
                margin-top: ${cardSpacing};
                margin-${$imagePosition}: ${cardSpacing};
            `) ||
            ($imageFit === 'outset' &&
                css`
                margin-top: 0;
                margin-${$imagePosition}: 0;
            `)
        };
    `,
);

export const Main = styled.div<{ $imagePosition: ImagePosition }>(({ $imagePosition }) => {
    const $oppositePosition = $imagePosition === 'left' ? 'right' : 'left';

    return css`
        grid-area: main;
        margin-top: ${cardSpacing};
        margin-bottom: ${cardSpacing};
        margin-${$oppositePosition}: ${cardSpacing};
    `;
});

const Text = styled.div`
    hyphens: none;
    color: ${getPurpurColor('textDefault')};
    font-family: ${getPurpurTypography('familyDefault')};
    font-size: ${getPurpurTypography('scale100')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
    font-weight: ${getPurpurTypography('weightNormal')};
`;

export const Title = styled(Text)`
    font-weight: ${getPurpurTypography('weightBold')};
`;
export const Body = styled(Text)`
    margin-top: ${getPurpurSpacing('50')};
`;
